// src/services/smoking.js
//
// A patient's smoking status: one of three standard choices (a dropdown on the patient
// page), plus a free-text note for details ("quit 2010, 30 pack-years"). Firebase-free
// and tested (smoking.test.js).
//
// A PFT prints smoking status in its own words. parseSmoking() maps those words to a
// choice ONLY when it is clear, and always keeps the printed words as the note, so
// nothing is lost. Unclear wording leaves the choice empty for a person to decide.

export const SMOKING_OPTIONS = ["Never smoker", "Former smoker", "Current smoker"];

const has = (s, re) => re.test(s);

/** Printed wording -> { status: one of SMOKING_OPTIONS or "", note }. */
export const parseSmoking = (text) => {
  const raw = String(text == null ? "" : text).trim();
  if (!raw) return { status: "", note: "" };
  const s = raw.toLowerCase();
  const never = has(s, /\b(never|non-?smoker|nonsmoker|no tobacco|denies)\b/);
  const former = has(s, /\b(former|ex-?smoker|ex\b|quit|stopped|past smoker|previous)/);
  const current = has(s, /\b(current|active|smokes|every day|daily|some days)\b/);
  const matches = [never, former, current].filter(Boolean).length;
  const status = matches === 1 ? (never ? "Never smoker" : former ? "Former smoker" : "Current smoker") : "";
  // The note is the printed wording, unless it IS the choice (nothing to add).
  const note = status && raw.toLowerCase() === status.toLowerCase() ? "" : raw;
  return { status, note };
};
